import { guardChildNodeByType } from '@utils/ast';
import { decodeHtmlEntities, whitelistHtml } from '@utils/common';

function parseCaption(node) {
  const metaTextNode = Array.from(node.childNodes).find(
    guardChildNodeByType("MetaText")
  );
  return {
    authorOrArtist: extractCaption(metaTextNode, "Author"),
    caption: extractCaption(metaTextNode, "Caption"),
    copyright: extractCaption(metaTextNode, "CreditLine"),
    country: extractCaption(metaTextNode, "Country"),
    description: extractCaption(metaTextNode, "Description"),
    duration: extractCaption(metaTextNode, "Duration"),
    numberOfPages: extractCaption(metaTextNode, "NumberOfPages"),
    title: extractCaption(metaTextNode, "Title"),
    year: extractCaption(metaTextNode, "Year")
  };
}
function extractCaption(metaTextNode, captionTag) {
  if (!metaTextNode) {
    return void 0;
  }
  const captionNode = Array.from(metaTextNode.childNodes).find(
    guardChildNodeByType(captionTag)
  );
  if (!captionNode) {
    return void 0;
  }
  const caption = captionNode.textContent;
  if (caption !== null) {
    return {
      showInContext: captionNode.getAttribute("show-in-context") === "true",
      showOutsideContext: captionNode.getAttribute("show-out-of-context") === "true",
      value: decodeHtmlEntities(whitelistHtml(caption))
    };
  } else {
    return void 0;
  }
}
function parseCaptionDisplayMode(node) {
  if (node.getAttribute("showTexts") !== "true") {
    return void 0;
  }
  return node.getAttribute("textsOnTop") === "true" ? "above" : "below";
}

export { parseCaption, parseCaptionDisplayMode };
//# sourceMappingURL=util.parse-caption.js.map
